import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import {
  ISchedulerNavMenuItem,
  SchedulerNavigationMenuQuery
} from '../../../views/aside/scheduler_navigation/queries/scheduler_navigation_menu_query';
import { RegistrationOneClickModel } from '../../../views/registration/models/registration_one_click_model';
import { SectionSelectionsModel } from '../../section_selections/models/section_selections_model';
import { RequestStateQuery } from '../../../request_state/queries/request_state_query';
import { RequestStateModel } from '../../../request_state/models/request_state_model';

interface ISelectedSectionActionsMenuQuery {
  menuItems: ISchedulerNavMenuItem[];
  showMenu: boolean;
}

export class SelectedSectionActionsMenuQuery implements IQuery {
  private _result: ISelectedSectionActionsMenuQuery;
  private multiSectionsActions = ['registerSections', 'waitlistSections'];

  constructor(
    private ngSchedulerNavigationMenuQuery: SchedulerNavigationMenuQuery,
    private ngRegistrationOneClickModel: RegistrationOneClickModel,
    private ngSectionSelectionsModel: SectionSelectionsModel
  ) {
    Query.registerQuery(this, ngRegistrationOneClickModel, ngSectionSelectionsModel);
  }

  getSelectedSectionActionsMenuItems(menuItems: ISchedulerNavMenuItem[]) {
    const filterByValues = this.multiSectionsActions;
    const multiSectionActionsMenuItems = menuItems.filter((menuItem) => filterByValues.includes(menuItem.value));
    return multiSectionActionsMenuItems;
  }

  shouldShowSelectedSectionActionsMenu(selectedSectionActionsMenuItems: ISchedulerNavMenuItem[]) {
    const multiSectionsActionsMinimumLength = this.multiSectionsActions.length;
    const shouldShowSelectedSectionActionsMenu =
      selectedSectionActionsMenuItems.length >= multiSectionsActionsMinimumLength;
    return shouldShowSelectedSectionActionsMenu;
  }

  run() {
    const schedulerNavigationMenuItems = this.ngSchedulerNavigationMenuQuery.result.menuItems;
    const selectedSectionActionsMenuItems = this.getSelectedSectionActionsMenuItems(schedulerNavigationMenuItems);
    const shouldShowSelectedSectionActionsMenu = this.shouldShowSelectedSectionActionsMenu(
      selectedSectionActionsMenuItems
    );
    this._result = {
      menuItems: selectedSectionActionsMenuItems,
      showMenu: shouldShowSelectedSectionActionsMenu
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngSelectedSectionActionsMenuQuery', SelectedSectionActionsMenuQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/selected_section_actions_menu/queries/selected_section_actions_menu_query.ts